<div [hidden]="!rendered" class="nop-content">
  <ng-container *ngFor="let chunk of contentChunks">
    <div *ngIf="chunk?.type === 'html'" [innerHtml]="chunk?.html | safeHtml"></div>
    <div *ngIf="chunk?.type === 'Slider'" [id]="'widget-chunk-' + chunk.index">
      <app-banners [sliderId]="chunk.entityId"></app-banners>
    </div>
    <div *ngIf="chunk?.type === 'Collection'" [id]="'widget-chunk-' + chunk.index">
      <app-product-collections [collectionId]="chunk.entityId"></app-product-collections>
    </div>
    <div *ngIf="chunk?.type === 'Product'" [id]="'widget-chunk-' + chunk.index">
      <app-product-content [productId]="chunk.entityId"></app-product-content>
    </div>
    <div *ngIf="chunk?.type === 'Blog Post'" [id]="'widget-chunk-' + chunk.index">
      <app-blog-post-teaser [blogPostId]="chunk.entityId"></app-blog-post-teaser>
    </div>
    <div *ngIf="chunk?.type === 'Blog Category'" [id]="'widget-chunk-' + chunk.index">
      <app-blog-category [blogCategoryId]="chunk.entityId"></app-blog-category>
    </div>
    <div *ngIf="chunk?.type === 'Blog Carousel'" [id]="'widget-chunk-' + chunk.index">
      <app-blog-carousel [blogCategoryId]="chunk.entityId"></app-blog-carousel>
    </div>
  </ng-container>
</div>
